const ENV = { DEV: 'development', STAGING: 'staging', PRODUCTION: 'production'};
const env = process.env.NODE_ENV === ENV.STAGING ? ENV.DEV: process.env.NODE_ENV || ENV.DEV;
const config = require(`./${env}`);

config.env = env;
module.exports = config;